import { InjectionToken } from '@angular/core';
export type GtagDirectiveEvent = 'click' | 'change';
export const GtagDirectiveEventToken: InjectionToken<GtagDirectiveEvent> = new InjectionToken(
	'GtagDirectiveEventToken'
);
